import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import HowToRegIcon from '@mui/icons-material/HowToReg';

const ActionButtons = ({ 
    isOwnProfile, 
    onUpdateClick, 
    onFollow, 
    onFriendAction, 
    isFollowing, 
    friendStatus, 
    rLoading, 
    fLoading 
}) => {
    if (isOwnProfile) {
        return (
            <button className="btnPrimary" onClick={onUpdateClick}>
                Update
            </button>
        );
    }

    const renderFriendButtonContent = () => {
        if (fLoading) return "...";
        switch (friendStatus) {
            case "friends":
                return <><HowToRegIcon fontSize="small"/> Friends</>;
            case "sent":
                return <><PersonRemoveIcon fontSize="small"/> Request Sent</>;
            case "received":
                return <><PersonAddIcon fontSize="small"/> Accept Request</>;
            default: 
                return <><PersonAddIcon fontSize="small"/> Add Friend</>;
        }
    };

    return (
        <>
            <button className="btnPrimary" onClick={onFollow} disabled={rLoading}>
                {rLoading ? "..." : (isFollowing ? "Following" : "Follow")}
            </button>

            <button
                className={`btnFriend ${friendStatus ? 'status-' + friendStatus : 'add'}`}
                onClick={onFriendAction}
                disabled={fLoading}
            >
                {renderFriendButtonContent()}
            </button>
        </>
    );
};

export default ActionButtons;